import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import ValueParser from "components/ValueParser";
import { memo } from "react";
import { Button } from "react-bootstrap";

type Props = {
  open: boolean;
  handleClose: () => void;
  details: any;
  footer?: {
    onClick: () => void;
    label: string;
  };
};

const DonationDetailsModal = ({
  handleClose,
  open,
  details,
  footer,
}: Props) => {
  return (
    <MolhamModalOffcanvas
      show={open}
      onHide={handleClose}
      body={{ className: "p-0" }}
    >
      <div>
        {details?.map((detail, index) => {
          const isLast = index === details.length - 1;
          return (
            <div
              className={`d-flex align-items-center justify-content-between ${
                !isLast && "border-bottom"
              } p-3`}
              key={index}
            >
              <span className="font-size-md d-flex mb-0">
                {detail?.label} :
              </span>
              <ValueParser detail={detail} closeOnLinkClick />
            </div>
          );
        })}
        {footer && (
          <div className="d-flex align-items-center w-100 p-3 border-top">
            <Button className="w-100" onClick={footer.onClick}>
              {footer.label}
            </Button>
          </div>
        )}
      </div>
    </MolhamModalOffcanvas>
  );
};

export default memo(DonationDetailsModal);
